export default "__VITE_ASSET__BgzJqdC6__"